// Single source of truth for VINEPASS (Pty) Ltd registered company details.
// Imported by Footer, AboutPage and every legal page so a future change
// (rebrand, registration number, address) is a one-line edit.
export const COMPANY = {
  legalName: 'VINEPASS (Pty) Ltd',
  registrationNumber: '2026/412801/07',
  country: 'South Africa',
  city: 'Stellenbosch, Western Cape',
  contactEmail: 'info@vinepass.co.za',
  ticketSupportEmail: 'tickets@vinepass.co.za',
  website: 'www.vinepass.co.za',
};

// Inline registration line used in footers and legal page bodies.
export const COMPANY_FOOTER_LINE = `${COMPANY.legalName} | Reg No: ${COMPANY.registrationNumber} | ${COMPANY.country}`;
